module.exports = __webpack_public_path__ + "static/media/18ECA1.5d7dffd9.jpg";